import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const user = this.authService.userValue;
    const isUserLoggedIn = user && user.token;
   
    if (isUserLoggedIn) {
      const headers: any = {
        Authorization: `Bearer ${user.token}`
      };

      const impersonatingAgency = localStorage.getItem('impersonatingAgency');
      if (impersonatingAgency) {
        headers['X-Impersonate-Agency'] = impersonatingAgency;
      }

      request = request.clone({
        setHeaders: headers
      });
    }

    return next.handle(request);
  }
}
